import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  AUDIT_RESULTS_CLEAR,
  AUDIT_RESULTS_CLEAR_RESULTS,
  AUDIT_RESULTS_FETCH_COMPLETED_AUDIT_REQUEST,
  AUDIT_RESULTS_FETCH_INCIDENTS_COMPARISON_REQUEST,
  AUDIT_RESULTS_SAVE_ASSET_AUDIT,
} from '../../../actions/actionTypes';

const saveAssetAudit = fetchReducerGenerator(
  [
    AUDIT_RESULTS_CLEAR,
    AUDIT_RESULTS_CLEAR_RESULTS,
    AUDIT_RESULTS_FETCH_COMPLETED_AUDIT_REQUEST,
    AUDIT_RESULTS_FETCH_INCIDENTS_COMPARISON_REQUEST,
  ],
  AUDIT_RESULTS_SAVE_ASSET_AUDIT
);

export default saveAssetAudit;
